var map = {
	"./black/shanchu.png": "sZqG",
	"./blue/shanchu.png": "ZRGt",
	"./white/shanchu.png": "j2Mt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MGD2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/shanchu\.png$
// module id = MGD2
// module chunks = 24